import Range from '@/modules/common/components/form/range'

export class StockItemMovementsFilter {
  range: Range | null = null
}
